// ─── Single source of truth for brand contact data ──────────────────────────
// All WhatsApp links and phone displays MUST use these constants.
// Old number (19983606010) is permanently deprecated.

/** Canonical production URL — every canonical/og/sitemap MUST use this. */
export const SITE_URL = 'https://nathof.com.br';

export const BRAND_CONTACT = {
  /** Use in wa.me links: `https://wa.me/${BRAND_CONTACT.whatsappInternational}` */
  whatsappInternational: '5519984150022',
  /** Human-readable display */
  whatsappDisplay: '(19) 98415-0022',
  /** tel: link format */
  whatsappTel: '+5519984150022',
  /** SAC e-mail */
  email: 'sac@nathof.com.br',
} as const;

// ── Paleta oficial NAT HOF (Manual Jan/2026) ─────────────────────────────────
export const BRAND_COLORS = {
  // Azuis institucionais
  deep:       '#2f4157',
  blue:       '#5e83af',
  teal:       '#72baa2',
  light:      '#add1ef',

  // Verdes naturais
  olive:      '#a6b65b',
  moss:       '#7a852a',
  sage:       '#aac4a3',
  mint:       '#a1d4ab',

  // Terrosos e quentes
  peach:      '#f1ab7f',
  straw:      '#ffedaa',
  lavender:   '#b0bddf',
  terra:      '#af7e5d',

  // Neutros claros
  beige:      '#ded8c0',
  cream:      '#e5e2cf',
  warm:       '#f9f5ec',
  white:      '#faf9f7',

  // Linha CLINIC (azuis)
  clinic: {
    primary:   '#2f4157',
    secondary: '#5e83af',
    accent:    '#add1ef',
    bg:        '#f0f4f9',
  },

  // Linha CARE (naturais)
  care: {
    primary:   '#a6b65b',
    secondary: '#f1ab7f',
    accent:    '#ffedaa',
    bg:        '#f9f5ec',
  },
} as const;
